import { CspConfigs } from "components/Integrations/types";

import { awsLambdaNotifyInstaller } from "./notify";
import { AwsLambdaNotifierInstaller } from "./types";

export const awsLambdaNotifierIntegration = (
  cspConfigs: Pick<CspConfigs, "aws">
): AwsLambdaNotifierInstaller => ({
  base: {},
  notify: awsLambdaNotifyInstaller(cspConfigs),
});
